import { render } from "./view-channel.vue?vue&type=template&id=15cdfdd8"
import script from "./view-channel.vue?vue&type=script&lang=js"
export * from "./view-channel.vue?vue&type=script&lang=js"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__